import {getToken} from "@/scripts/Common";
import { jwtDecode } from "jwt-decode";
import {Claims} from "@/authorization/constants/jwtClaimConstants";
const getPermissionClaims = () => {
  const token = getToken();
  if (!token) return [];
  try {
    const raw = Object.values(jwtDecode(token))[Claims.permissions];
    if (Array.isArray(raw)) return raw as string[];
    if (typeof raw === 'string') return raw.split(',');
  } catch {
    // invalid token
  }
  return [];
};

const hasPermissions = (...permissions: string[]): boolean => {
  const claims = getPermissionClaims();
  return permissions.every((p) => claims.includes(p));
}

const hasAnyPermission = (...permissions: string[]): boolean => {
  const claims = getPermissionClaims();
  return permissions.some((p) => claims.includes(p));
}

const decodeTokenField = <T>(claimIndex: Claims, fallback: T): T => {
  const token = getToken();
  if (!token) return fallback;
  try {
    return Object.values(jwtDecode(token))[claimIndex] as T ?? fallback;
  } catch {
    return fallback;
  }
};

const getCurrentLoggedInUserId = () => decodeTokenField<string>(Claims.userId, '');
const getCurrentLoggedInUserType = () => decodeTokenField<string>(Claims.userType, '');
const getCurrentLoggedInUserRoles = () => decodeTokenField<string[]>(Claims.userRoles, []);
const getCurrentLoggedInUsername = () => decodeTokenField<string>(Claims.userName, '');

export {
  hasPermissions,
  hasAnyPermission,
  getCurrentLoggedInUserId,
  getCurrentLoggedInUserType,
  getCurrentLoggedInUserRoles,
  getCurrentLoggedInUsername
}
